import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    data-name="Livello 2"
    {...props}
  >
    <circle
      cx={24}
      cy={24}
      r={24}
      style={{
        strokeWidth: 0,
        fill: "#060b0c",
      }}
    />
    <circle
      cx={23.42}
      cy={33.5}
      r={2}
      style={{
        fill: "#00a4b7",
        strokeWidth: 0,
      }}
    />
    <path
      d="M18.77 18.92v-1.39c0-1.47.5-2.7 1.48-3.63.97-.92 2.24-1.39 3.78-1.39s2.77.46 3.73 1.37c.97.93 1.47 2.14 1.47 3.62 0 .89-.17 1.69-.52 2.38-.33.65-.74 1.21-1.21 1.67-.41.4-.97.88-1.65 1.42-.89.71-1.56 1.33-1.97 1.86-.31.4-.46.93-.46 1.63v3.05"
      style={{
        fill: "none",
        stroke: "#00a4b7",
        strokeMiterlimit: 10,
        strokeWidth: 2,
      }}
    />
  </svg>
)
export default SvgComponent
